module.exports = __webpack_public_path__ + "img/wflogo.ac02ab4d.png";